<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col
      cols="12"
      sm="8"
      md="6"
    >
      <v-form @submit.prevent="login">
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Prihlásenie</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-text-field
              v-model="username"
              label="Prihlasovacie meno alebo emailová adresa"
              name="login"
              prepend-icon="mdi-account"
              type="text"
            />
            <v-text-field
              id="password"
              v-model="password"
              label="Heslo"
              name="password"
              prepend-icon="mdi-lock"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            />
            <v-alert
              v-if="error || loginErrorMessage"
              type="error"
              dense
              outlined
              class="mb-3"
            >
              {{ loginErrorMessage || "Prihlásenie zlyhalo. Skontrolujte údaje a skúste to znova." }}
            </v-alert>
            <v-card-actions>
              <v-row justify="space-between">
                <v-col cols="auto">

                  <v-btn
                    color="primary"
                    outlined
                    to="password_reset"
                  >
                    Zabudnuté heslo
                  </v-btn>
                </v-col>
                <v-col cols="auto">

                  <v-btn
                    color="primary"
                    type="submit"
                    :loading="authenticating"
                    :disabled="authenticating"
                  >
                    Prihlásiť sa
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    source: String,
  },
  data() {
    return {
      drawer: null,
      username: "",
      password: "",
      show1: false,
      loginErrorMessage: "",
    };
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    authenticating() {
      return this.$store.state.auth.authenticating;
    },
    error() {
      return this.$store.state.auth.error;
    },
  },

  methods: {
    login() {
      if (this.authenticating) {
        return;
      }

      this.loginErrorMessage = "";

      if (!this.username || !this.username.trim() || !this.password) {
        this.loginErrorMessage = "Prihlasovacie údaje neboli zadané.";
        return;
      }

      let username = this.username;
      let password = this.password;

      this.$store
        .dispatch("auth/login", { username, password })
        .then(() => {
          this.$router.push("/");
        })
        .catch((error) => {
          const details = error?.response?.data;

          if (details?.non_field_errors && details.non_field_errors.length) {
            this.loginErrorMessage = details.non_field_errors[0];
            return;
          }

          this.loginErrorMessage = "Prihlásenie zlyhalo. Skontrolujte údaje a skúste to znova.";
        });
    },
  },
};
</script>